import { ColumnDef } from "@tanstack/react-table";
import { RemainingRow } from "../model";

const cellEmphasis = (val: any, isTotal?: boolean) => (
  <span className={isTotal ? "font-semibold" : ""}>{val ?? "-"}</span>
);

export const remainingColumns: ColumnDef<RemainingRow>[] = [
  {
    header: "Currencies",
    accessorFn: (r) => r.currencies,
  },
  {
    header: "Remaining to be received",
    accessorFn: (r) => r.remainingInflow,
  },
  {
    header: "Remaining to be paid",
    accessorFn: (r) => r.remainingOutflow,
  },
  {
    header: "Difference",
    accessorFn: (r) => Number(r.remainingInflow - r.remainingOutflow).toFixed(2),
  },
];
